/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
//window.Vue = require('vue');
import moment from 'moment';
import Vuetify from './plugins/vuetify';


import { Form, HasError, AlertError } from 'vform';
window.Form = Form;

import Gate from "./Gate";
Vue.prototype.$gate = new Gate(window.user);


import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import Swal from 'sweetalert2';

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

import { TablePlugin } from 'bootstrap-vue'
Vue.use(TablePlugin)

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
window.Swal = Swal;
window.Toast = Toast;

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red',
    height: '3px'
  });


Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)


/**
 * Routes imports and assigning
 */
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import routes from './routes';



const router = new VueRouter({
    mode: 'history',
    routes
});
// Routes End



/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


// Components
Vue.component('pagination', require('laravel-vue-pagination'));
// Vue.component('dashboard', require('./components/Dashboard.vue'));

Vue.component(
    'passport-clients',
    require('./components/passport/Clients.vue').default
);

Vue.component(
    'passport-authorized-clients',
    require('./components/passport/AuthorizedClients.vue').default
);
Vue.component(
    'passport-personal-access-tokens',
    require('./components/passport/PersonalAccessTokens.vue').default
);

Vue.component('not-found', require('./components/NotFound.vue').default);
Vue.component('footers', require('./components/footer').default);

Vue.component('right-modal-widget', require('./components/widgets/RightModalWidget').default);
Vue.component('right-cart-widget', require('./components/widgets/RighCartWidget.vue').default);
Vue.component('center-modal-widget', require('./components/widgets/CenterModalWidget.vue').default);
Vue.component('info-widget', require('./components/widgets/InfoWidget').default);
Vue.component('drop-input', require('./components/widgets/DropInput.vue').default);
Vue.component('time-widget', require('./components/widgets/timeWidget.vue').default);
// Vue.component('search-widget ', require('./components/widgets/SearchWidget').default);

Vue.component('login-component', require('./components/auth/Login.vue').default);


Vue.component('site-component', require('./components/page/site/site.vue').default);


// Filter Section

Vue.filter('myDate',function(created){
    return moment(created).format('MMMM Do YYYY');
});

Vue.component('ZakazAll', require('./components/page/zakaz/ZakazAll').default);
Vue.component('ZakazToday', require('./components/page/zakaz/ZakazToday').default);
Vue.component('ZakazFuture', require('./components/page/zakaz/ZakazFuture').default);
Vue.component('ZakazClient', require('./components/page/zakaz/ZakazClient').default);
Vue.component('ZakazTrash', require('./components/page/zakaz/ZakazTrash').default);

// end Filter
Vue.prototype.$count=0;
Vue.prototype.$data_cart=[];
Vue.prototype.$modal=false;

const app = new Vue({
    vuetify: Vuetify,
    el: '#app',
    router
});
